import { render, staticRenderFns } from "./galaxsys-frame.vue?vue&type=template&id=8ff2c1ec"
import script from "./galaxsys-frame.vue?vue&type=script&lang=js"
export * from "./galaxsys-frame.vue?vue&type=script&lang=js"
import style0 from "./galaxsys-frame.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/galaxsys/galaxsys-frame.vue
// module id = yaWS
// module chunks = 0